/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base'
import { MsgBox, Vue, Routes } from '../../app.vues';
//
import goodsCategApi from '../../api/goodsCateg';

import SwbCategTreeMultiSelect from './CategTreeMultiSelect';
import SwbServcCategTreeMultiSelect from './ServcCategTreeMultiSelect';
import SwbMerchtFusedServcCatForSelect from './MerchtFusedServcCatForSelect';
import SwbMerchtFusedGoodsCatForSelect from './MerchtFusedGoodsCatForSelect';

Vue.regist(SwbCategTreeMultiSelect);
Vue.regist(SwbServcCategTreeMultiSelect);
Vue.regist(SwbMerchtFusedServcCatForSelect);
Vue.regist(SwbMerchtFusedGoodsCatForSelect);

//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openCategTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let defaultCheckedItems = displayDataList || [];
    let model = dlgConfig['model'] || null;
    if(model == null) {
        model = {};
        model.catIdColumn = "catId"; //
        model.catNameColumn = "catName";
    }
    //
    Vue.$showDialog({
        title: '商品分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-categ-tree-multi-select :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model="model" ref="swb_categ_tree_multi_select"></swb-categ-tree-multi-select>' +
        '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_categ_tree_multi_select.getDlgResult() || {};
            if(result.type == "info") {
                let catList = result.data;
                //
                console.log(catList);
                callback(catList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openServcCategTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '服务分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-categ-tree-multi-select :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_servc_categ_tree_multi_select"></swb-servc-categ-tree-multi-select>' +
        '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_categ_tree_multi_select.getDlgResult() || {};
            if(result.type == "info") {
                let catList = result.data;
                //
                console.log(catList);
                callback(catList);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

export function openMerchtFusedServcCategSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let multiSelect = dlgConfig['multiSelect'] || false;
    let initCheckedItem = dlgConfig['initCheckedItem'] || null;
    let noPostFilters = dlgConfig['noPostFilters'] == null ? false : dlgConfig['noPostFilters'];
    let initCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '服务分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-fused-servc-cat-select :noPostFilters="noPostFilters" :multiSelect = "multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems = "initCheckedItems" ref="swb_fused_servc_cat_select"></swb-fused-servc-cat-select>' +
        '</div>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            initCheckedItems: initCheckedItems,
            noPostFilters: noPostFilters
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_fused_servc_cat_select.getDlgResult() || {};
            callback(result);
            // if(result.type == "info") {
            //     let catList = result.data;
            //     //
            //     callback(catList);
            // } else {
            //     MsgBox.warning(result.message);
            //     return false;
            // }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

export function openMerchtFusedGoodsCategSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let multiSelect = dlgConfig['multiSelect'] || false;
    let initCheckedItem = dlgConfig['initCheckedItem'] || null;
    let noPostFilters = dlgConfig['noPostFilters'] == null ? false : dlgConfig['noPostFilters'];
    let initCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '商品分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-fused-goods-cat-select :noPostFilters="noPostFilters" :multiSelect = "multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems = "initCheckedItems" ref="swb_fused_goods_cat_select"></swb-fused-goods-cat-select>' +
        '</div>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            initCheckedItems: initCheckedItems,
            noPostFilters: noPostFilters
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_fused_goods_cat_select.getDlgResult() || {};
            callback(result);
            // if(result.type == "info") {
            //     let catList = result.data;
            //     //
            //     callback(catList);
            // } else {
            //     MsgBox.warning(result.message);
            //     return false;
            // }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
// 常用服务分组

import SwbDevcGroupSave from './DevcGroupSave';
Vue.regist(SwbDevcGroupSave);

export function openDevcGroupDlg(id, callback) {
    //
    let title = Utils.isNoB(id) ? "分类分组 - 新增" : "分类分组 - 修改";
    Vue.$showDialog({
        title: title,
        width: 500,
        height: 300,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-devc-group-save :id = "id" ref="swb_devc_group_save"></swb-devc-group-save>' +
        '</div>',
        data: {
            id: id || null
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_group_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                // MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbServcTypeChargeItemListSave from './ServcTypeChargeItemListSave';
Vue.regist(SwbServcTypeChargeItemListSave);

export function openServcTypeChargeItemListSaveDlg(initServcTypeId, callback) {
    let theDlg = Vue.$showDialog({
        title: "收费项 - 新增",
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-servc-type-charge-item-save-batch :initServcTypeId="initServcTypeId" ref="swb_servc_type_charge_item_save_batch"></swb-servc-type-charge-item-save-batch>',
        data: {
            initServcTypeId: initServcTypeId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_type_charge_item_save_batch.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbServcTypeChargeItemListSelect from './ServcTypeChargeItemListSelect';
Vue.regist(SwbServcTypeChargeItemListSelect);

export function openServcTypeChargeItemListSelect(params, callback) {
    let servcTypeId = params['servcTypeId'];
    let selectIds = params['selectIds'] || [];
    let showAddFlag = params['showAddFlag'] || false
    let theDlg = Vue.$showDialog({
        title: "收费项 - 选择",
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-servc-type-charge-item-list-select :servcTypeId="servcTypeId" :selectIds="selectIds" :showAddFlag="showAddFlag" ref="swb_servc_type_charge_item_list_select"></swb-servc-type-charge-item-list-select>',
        data: {
            servcTypeId: servcTypeId,
            selectIds: selectIds,
            showAddFlag: showAddFlag,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_type_charge_item_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

//
import SwbBrandListForSelect from './BrandListForSelect';
Vue.regist(SwbBrandListForSelect);
//
export function openBrandListSelectDlg(checkBox, dlgConfig, callback) {
    let selectIds = dlgConfig['selectIds'] || [];
    let filter = dlgConfig['filter'] || {};
    Vue.$showDialog({
        title: '品牌 - 选择',
        width: 900,
        height: 800,
        showCloseBtn: true,
        template: '<div>' +
            '<swb-brand-list-for-select :checkBox = "checkBox" :filter="filter" :selectIds="selectIds" ref="swb_brand_list_for_select"></swb-brand-list-for-select>' +
            '</div>',
        data: {
            checkBox: null,
            filter: filter,
            selectIds: selectIds
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_brand_list_for_select.getDlgResult() || {};
            if (result.type === 'info') {
                let brandList = result.data;
                callback(brandList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.checkBox = checkBox || false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/categ/selectDlg.js
// module id = 39
// module chunks = 1